import { useGameModuleDispatch, useGameModuleState, GAME_MODULE_ACTION } from "..";
import { useQuery } from "react-query";
import makeRequest from "../../../utils/network/make-request";
import { useCallback, useEffect } from "react";

function getGame() {
    return makeRequest(process.env.PUBLIC_URL + '/data.json').then(data => {
        return data.data
    });
}
export default function useGame() {
    const dispatch = useGameModuleDispatch();
    const { game, isLoading } = useGameModuleState();

    const onSuccess = useCallback(data => {
        dispatch({
            type: GAME_MODULE_ACTION.FETCH_SUCCESS,
            payload: {
                game: data
            }
        })
    }, [dispatch])

    const { isFetching, data, error, refetch } = useQuery('demo-query', getGame, {
        manual: true,
        onSuccess
    })

    useEffect(() => {
        if (!isLoading && !game) {
            dispatch({ type: GAME_MODULE_ACTION.FETCH })
            refetch();
        }
    })

    return {
        game: error ? game : data as GameData,
        error,
        isLoading: isFetching
    }
}
